var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-primary-500 mr-2 block cursor-pointer",on:{"click":_vm.goBack}},[_vm._v("← Go Back")])}
var staticRenderFns = []

export { render, staticRenderFns }